
import setters from './setters';
import undo from './undo';

const actions = {
    ...setters,
    ...undo,
};

export default actions;
